import { typography } from '@primer-io/goat'
import Spacer from 'components/Spacer'
import { H1 } from 'ds/TextGoat'
import React from 'react'
import styled from 'styled-components'

const Section = styled.section`
	margin-top: 48px;
`

const Description = styled.div`
	${typography('body-large')};
`

export const Title = H1

export default function TopSection({ title, description, documentTitle }) {
	const h1Title = documentTitle ?? title

	return (
		<Section>
			{h1Title && <H1>{h1Title}</H1>}
			{h1Title && description && <Spacer.V size='32px' />}
			{description && <Description>{description}</Description>}
		</Section>
	)
}
